import React, { useState } from 'react';
import { Table, Input, Tag ,Empty,ConfigProvider} from 'antd';
import { useNavigate } from 'react-router-dom';
import JW_PO from './JW_PO';
import EmptyData from '../Assets/EmptyData.jpg';

const { Search } = Input;


const initialData = [
  {
    key: '1',
    sno: '01',
    month: 'June',
    fileId: 'KARWAR',
    totalMspc: '1200',
    planned: '200 T',
    actuals: '180 T',
    difference: '20 t',
    finalCount: '20 t',
    status: 'Pending',
  },
  {
    key: '2',
    sno: '02',
    month: 'June',
    fileId: 'KARWAR',
    totalMspc: '1200',
    planned: '200 T',
    actuals: '180 T',
    difference: '20 t',
    finalCount: '20 t',
    status: 'Completed',
  },
  {
    key: '3',
    sno: '03',
    month: 'June',
    fileId: 'KARWAR',
    totalMspc: '1200',
    planned: '200 T',
    actuals: '180 T',
    difference: '20 t',
    finalCount: '20 t',
    status: 'Completed',
  },
  {
    key: '4',
    sno: '04',
    month: 'June',
    fileId: 'KARWAR',
    totalMspc: '1200',
    planned: '200 T',
    actuals: '180 T',
    difference: '20 t',
    finalCount: '20 t',
    status: 'Completed',
  },
  {
    key: '5',
    sno: '05',
    month: 'June',
    fileId: 'KAR',
    totalMspc: '1300',
    planned: '200 T',
    actuals: '180 T',
    difference: '20 t',
    finalCount: '20 t',
    status: 'Completed',
  },
];

const JobWork_PO = () => {
  const navigate=useNavigate();
  const [filteredData, setFilteredData] = useState(initialData);
   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const columns = [
  { title: 'S.No', dataIndex: 'sno', key: 'sno' },
  { title: 'Month', dataIndex: 'month', key: 'month' },
  { title: 'File ID', dataIndex: 'fileId', key: 'fileId' },
  { title: 'Total MSPC', dataIndex: 'totalMspc', key: 'totalMspc' },
  { title: 'Planned', dataIndex: 'planned', key: 'planned' },
  { title: 'Actuals', dataIndex: 'actuals', key: 'actuals' },
  { title: 'Difference', dataIndex: 'difference', key: 'difference' },
  { title: 'Final Count', dataIndex: 'finalCount', key: 'finalCount' },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (status,record) =>
        status === "Pending" ? (
          <Tag
            color="blue"
            style={{ cursor: "pointer",borderRadius:"73.45px" }}
            onClick={() => navigate("/jobwork/jobwork_po/jw_po", { state: { record } })}
          >
            {status}
          </Tag>
        ) : (
          <Tag color="green" style={{borderRadius:"73.45px"}}>{status}</Tag>
        ),
  },
];

  const onSearch = (value) => {
    const searchValue = value.toLowerCase();
    const filtered = initialData.filter((item) =>
      Object.values(item).some((field) =>
        String(field).toLowerCase().includes(searchValue)
      )
    );
    setFilteredData(filtered);
  };
   const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys) => {
      setSelectedRowKeys(newSelectedRowKeys);
    },
  };

  return (
    <div style={{ padding: '20px' }}>
      <Search
        placeholder="Search By Name or MSPC"
        allowClear
        onChange={(e) => onSearch(e.target.value)}
        style={{ width: 500, marginBottom: 20 }}
      />
      <ConfigProvider
              renderEmpty={() => (
                <Empty
                  image={EmptyData}
                  description="No CategoryMaster Data Available"
                  imageStyle={{ height: 200 }}
                />
              )}
            >
      <Table
      rowSelection={rowSelection}
        columns={columns}
        dataSource={filteredData}
        pagination={false}
        size="small"
        bordered
      />
      </ConfigProvider>
    </div>
  );
};

export default JobWork_PO;
